import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts';
import { CashierSellingScreen } from '../screens/cashierselling';
import LoginScreen from '../screens/login/LoginScreen';
import TerminalSetupScreen from '../screens/login/TerminalSetupScreen';
import {
  TERMINAL_SETUP_CHANGED_EVENT,
  readTerminalSetup,
} from '../screens/login/terminalSetup';

const AppRouter: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [setup, setSetup] = useState(() => readTerminalSetup());

  useEffect(() => {
    const sync = () => setSetup(readTerminalSetup());
    window.addEventListener(TERMINAL_SETUP_CHANGED_EVENT, sync);
    return () => window.removeEventListener(TERMINAL_SETUP_CHANGED_EVENT, sync);
  }, []);

  if (isLoading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-brand-dark">
        <div className="text-center">
          <div className="inline-block w-10 h-10 border-2 border-brand border-t-transparent rounded-full animate-spin mb-4" />
          <p className="text-sm text-gray-400">Loading…</p>
        </div>
      </div>
    );
  }

  if (!setup) {
    return <TerminalSetupScreen />;
  }

  return isAuthenticated ? <CashierSellingScreen /> : <LoginScreen />;
};

export default AppRouter; 